import './style.scss';

/**
 * Ken Burns Effect — frontend script (Pro)
 */

const applyPausedState = (slider, paused) => {
	slider.classList.toggle('is-paused', !!paused);
};

const bindPauseControls = (slider) => {
	if (slider.dataset.kenBurnsControlsBound === '1') {
		return;
	}

	const pauseBtn = slider.querySelector('.swiper-button-pause');
	const playBtn = slider.querySelector('.swiper-button-play');

	if (pauseBtn) {
		pauseBtn.addEventListener('click', () =>
			applyPausedState(slider, true)
		);
	}

	if (playBtn) {
		playBtn.addEventListener('click', () =>
			applyPausedState(slider, false)
		);
	}

	slider.dataset.kenBurnsControlsBound = '1';
};

const bindSwiperAutoplayEvents = (slider) => {
	if (slider.dataset.kenBurnsSwiperBound === '1') {
		return;
	}

	const swiper = slider.swiper;
	if (!swiper || !swiper.on || !swiper.autoplay) {
		return;
	}

	applyPausedState(slider, !swiper.autoplay.running);

	swiper.on('autoplayStart', () => applyPausedState(slider, false));
	swiper.on('autoplayStop', () => applyPausedState(slider, true));

	slider.dataset.kenBurnsSwiperBound = '1';
};

const bindWhenSwiperReady = (slider, attempts = 0) => {
	bindSwiperAutoplayEvents(slider);

	if (slider.dataset.kenBurnsSwiperBound === '1') {
		return;
	}

	if (attempts >= 30) {
		return;
	}

	window.requestAnimationFrame(() =>
		bindWhenSwiperReady(slider, attempts + 1)
	);
};

const initSlider = (slider) => {
	if (!slider || slider.dataset.kenBurnsInit === '1') {
		return;
	}

	if (!slider.classList.contains('has-ken-burns')) {
		return;
	}

	slider.dataset.kenBurnsInit = '1';
	slider.classList.add('is-ken-burns-ready');
	bindPauseControls(slider);
	bindWhenSwiperReady(slider);
};

const initAll = (root = document) => {
	root.querySelectorAll('.mnorwise-slider.has-ken-burns').forEach(initSlider);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => initAll(document));
} else {
	initAll(document);
}

const observer = new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		mutation.addedNodes.forEach((node) => {
			if (!node || node.nodeType !== 1) {
				return;
			}
			if (node.matches?.('.mnorwise-slider.has-ken-burns')) {
				initSlider(node);
			}
			if (node.querySelectorAll) {
				initAll(node);
			}
		});
	});
});

observer.observe(document.body, { childList: true, subtree: true });
